module.exports = __webpack_public_path__ + "static/media/10UNOHRLLS8.52105da1.jpg";